import { useLocation } from 'react-router';

import { isNBAPage } from '#src/constants/routes.ts';

export const useIsNBAPage = () => {
  const location = useLocation();

  return isNBAPage(location.pathname);
};
